import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { connect } from 'react-redux';
import ToastService from '../Toasts/toastService';
import Loader from '../Spinners/spinnerPage';
import TextFieldGroup from '../common/textFieldGroup';
import { addAuth, getAuths } from '../../actions/authorizationActions';
import validateAddAuthorization from '../../validations/addAuthorizationValidation';
import UserApi from './../../api/user-api';

const AddAuthorizationPopUp = (props) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    dob: '',
    isManual: false,
  });
  const [showLoader, setShowLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [user, setUser] = useState(null);
  const [searchText, setSearchText] = useState('');

  const { firstName, lastName, dob, email, isManual } = formData;

  useEffect(() => {
    const initComponent = async () => {
      try {
        loadAuthorizations(1);
        let userData = await UserApi.getUserWithJwt();
        if (userData) {
          setUser(userData.Id);
        }
      } catch (error) {
      }
    };
    
    initComponent();
  }, []);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onCheckboxChange = (e) => {
    setFormData({ ...formData, isManual: e.target.checked });
  };

  const loadAuthorizations = (page) => {
    const req = {
      userId: user,
      page: page,
      searchText: searchText
    };
    props.getAuths(req);
  };

  const isValid = async () => {
    try {
      let validationResult = await validateAddAuthorization({
        ...formData,
        user,
        searchText
      });
      
      if (!validationResult.isValid) {
        setErrors(validationResult.errors);
      }
      return validationResult.isValid;
    } catch (error) {
      return false;
    }
  };

  const submitAuthorization = async () => {
    setShowLoader(true);
    try {
      const validForm = await isValid();
      if (validForm === true) {        
        
        setErrors({});
        await props.addAuth({
          ...formData,
          user,
          searchText
        });
        ToastService.show('The authorization has been successfully added!', 'success');
        props.onHide();
        loadAuthorizations(1);
      }
    } catch (error) {
      console.log('error', error.response);
      ToastService.show(`${error.response.statusText}, please contact customer support.`, 'error');
      props.onHide();
    } finally {
      setShowLoader(false);
      loadAuthorizations(1);
    }
  };

  const loader = showLoader ? <Loader /> : null;

  return (
    <Modal
      className='px-5'
      show={props.show}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
      onHide={props.onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          <figure className='icon-group mt-3'>
            <i className='material-icons'>playlist_add</i>
            <h3 className='heading ml-3 mt-3'>Add Authorization</h3>
          </figure>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TextFieldGroup
          label='First name'
          onChange={onChange}
          value={firstName}
          field='firstName'
          required={true}
          error={errors.firstName}
        />
        <TextFieldGroup
          label='Last name'
          onChange={onChange}
          value={lastName}
          field='lastName'
          required={true}
          error={errors.lastName}
        />
        <TextFieldGroup
          label='Date of Birth (Format: YYYY-MM-DD)'
          onChange={onChange}
          value={dob}
          field='dob'
          required={true}
          error={errors.dob}
        />
        <Form.Group className="mb-3">
          <Form.Check 
            type="checkbox"
            id="manual-checkbox"
            label="Manual"
            className="pl-0"
            checked={isManual}
            onChange={onCheckboxChange}
          />
        </Form.Group>
        {isManual && <p className="text-primary w-75">Notice: You have selected “Manual” as your FCRA authorization method. Use this option only if you intend to complete the process manually, which requires printing an FCRA-compliant form and obtaining a physical signature from the individual. For easier tracking and a streamlined experience, we highly recommend using the FCRA Authorization feature on Personnelgraph instead.</p>}
        {!isManual && 
          <TextFieldGroup
            label='Email'
            onChange={onChange}
            value={email}
            field='email'
            required={true}
            error={errors.email}
          />
        }
      </Modal.Body>
      <Modal.Footer>
        {loader}
        <Button onClick={submitAuthorization} className='primary mx-3 mt-3'>
          <i className='material-icons'>playlist_add_check</i>Add Authorization
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = state => {
  return {
    authList: state.authorizationReducer.authList
  };
};

export default connect(mapStateToProps, { addAuth, getAuths })(AddAuthorizationPopUp);